setTimeout(function (e) {
	$(".hr-home").addClass("hr-anim");
	$(".item-1").addClass("item-1-anim");
	$(".welcome-before").addClass("welcome-anim");
	$(".social-before").addClass("social-anim");
	$(".logo-before").addClass("logo-nav");
	$(".lottie").css("visibility", "visible");
	$(".reveal-img").addClass("reveal-img-anim");
	$(".title-reveal").addClass("title-reveal-anim");
}, 1);

const slides = [$(".slide-2"), $(".slide-loyalty"), $(".slide-3"), $(".slide-4")];
//need to make it so it stops firing once it has fired once
const observer = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				if (entry.target.classList.contains("slide-2")) {
					slide_2();
				} else if (entry.target.classList.contains("slide-loyalty")) {
					slide_loyalty();
				} else if (entry.target.classList.contains("slide-3")) {
					slide_3();
				} else if (entry.target.classList.contains("slide-4")) {
					slide_4();
				}
			}
		});
		// console.log(entries);
	},
	{
		threshold: 0.2,
	}
);

slides.forEach((slide) => {
	observer.observe(slide[0]);
});

function slide_2() {
	/*text above slider animation*/
	$(".text-reveal--anim2").addClass("text-anim2");
	/*slider animation*/
	$(".ps2-container").addClass("ps2-anim");
	/*slider controls navigation*/
	$(".custom-navigation2").addClass("cn2-anim");
	/*description animation*/
	$(".text-desc2").addClass("text-desc--anim2");
	$(".btn-b--anim2").addClass("btn--anim2");
}

function slide_loyalty() {
	/*text above slider animation*/
	$(".text-reveal--anim_loyalty").addClass("text-anim_loyalty");
	/*image animation*/
	$(".img_loyalty-container").addClass("img_loyalty-anim");
	/*description animation*/
	$(".text-desc_loyalty").addClass("text-desc--anim_loyalty");
	$(".btn-b--anim_loyalty").addClass("btn--anim_loyalty");
}

function slide_3() {
	/*text above slider animation*/
	$(".text-reveal--anim3").addClass("text-anim3");
	/*slider animation*/
	$(".ps3-container").addClass("ps3-anim");
	/*slider controls navigation*/
	$(".custom-navigation3").addClass("cn3-anim");
	/*description animation*/
	$(".text-desc3").addClass("text-desc--anim3");
	/*btn animation*/
	$(".btn-b--anim3").addClass("btn--anim3");
	$(".custom-navigation3").addClass("cn3-anim");
}

function slide_4() {
	/*text above slider animation*/
	$(".text-reveal--anim5").addClass("text-anim5");
	$(".col-1").addClass("col-1-anim");
	$(".col-2").addClass("col-2-anim");
	$(".col-3").addClass("col-3-anim");
	$(".col-4").addClass("col-4-anim");
	$(".col-5").addClass("col-5-anim");
}
